import O1HD from "../../../engines/gameEngine";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../BundleResourceConfig";
import { backPackEventMap } from "../config/BackpackEventConfig";
import NormalGameManager from "../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class feedBackPage extends cc.Component {

    @property({type:cc.Node,tooltip:"itemContent"})
    itemContent:cc.Node = null;

    objAry:string[] = [
        "50049",
        "50050",
        "50051",
        "50052"
    ];

    onLoad(){
        this.loadPage();
    }

    loadPage(){
        this.itemContent.children.forEach(async (n:cc.Node,index:number)=>{
            let backId = this.objAry[index];
            let bundle = await getOneBundle(BUNDLE_SMALL_NAME.backPackGameBundle,true);
            let nSp:cc.Sprite = n.getChildByName("sprite").getComponent(cc.Sprite);
            let backConfig = backPackEventMap()[backId];
            bundle.load(`backpackAssets/objSp/${backConfig.spPath}`,cc.SpriteFrame,(err,sps:cc.SpriteFrame)=>{
                if(err){
                    console.log(err,"加载背包物品图片失败");
                    return;
                }
                nSp.spriteFrame = sps;
            });
            let name = backConfig.name;
            let lbName:cc.Label = n.getChildByName("lbName").getComponent(cc.Label);
            lbName.string = name;
        });
    }

    onBtnComit(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        for(let i = 0;i<this.objAry.length;i++){
            let id = this.objAry[i];
            NormalGameManager._instance.onPushGoods(id,1);
        }
        NormalGameManager._instance.setGameData({isFirstOutSize:false});
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }

}
